import { render } from "./behavioralComponent.vue?vue&type=template&id=3c127a36&scoped=true"
import script from "./behavioralComponent.vue?vue&type=script&lang=js"
export * from "./behavioralComponent.vue?vue&type=script&lang=js"

import "./behavioralComponent.vue?vue&type=style&index=0&id=3c127a36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c127a36"]])

export default __exports__